export const getMenuData = [
  {
    category: true,
    title: '',
  },
  {
    title: 'Pregled',
    key: 'dashboard',
    icon: 'fe fe-home',
    // roles: ['admin'], // set user roles with access to this route
    count: 4,
    children: [
      {
        title: 'Zaposleni',
        key: 'employee-dashboard',
        url: '/dashboard/employee',
      },
      {
        title: 'Manager',
        key: 'manager-dashboard',
        url: '/dashboard/manager',
      },
    ],
  },
  // {
  //   category: true,
  //   title: 'Aplikacije',
  // },
  {
    title: 'Zaposleni',
    key: 'emoployees',
    icon: 'fe fe-users',
    children: [
      {
        title: 'Pregled zaposlenih',
        key: 'employee-list',
        url: '/apps/employees',
      },
      {
        title: 'Novi zaposleni',
        key: 'employee-new',
        url: '/apps/onboarding',
      },
    ],
  },
  {
    title: 'Otvorene pozicije',
    key: 'openpositions',
    icon: 'fe fe-user-plus',
    children: [
      {
        title: 'Pozicije',
        key: 'vacancies',
        url: '/apps/vacancies',
      },
      {
        title: 'Kandidati',
        key: 'candidates',
        url: '/apps/candidates',
      },
    ],
  },
  {
    title: 'Zadaci',
    key: 'ecommerce',
    icon: 'fe fe-layers',
    children: [
      {
        title: 'Lista',
        key: 'tasks',
        url: '/apps/tasks',
      },
      {
        title: 'Novi zadatak',
        key: 'new-task',
        url: '/apps/newtask',
      },
    ],
  },
  {
    title: 'Dokumentacija',
    key: 'extraApps',
    icon: 'fe fe-file-text',
    children: [
      {
        title: 'Ugovori',
        key: 'contracts',
        url: '/apps/contracts',
      },
      {
        title: 'Reversi',
        key: 'revers',
        url: '/apps/revers',
      },
    ],
  },
  {
    title: 'Imovina',
    key: 'auth',
    icon: 'fe fe-grid',
    children: [
      {
        title: 'Upravljanje',
        key: 'authLogin',
        url: '/auth/login',
      },
    ],
  },
  {
    category: true,
    title: 'Sistem',
  },
  {
    title: 'Upravljanje sistemom',
    key: 'antDesign',
    icon: 'fe fe-settings',
    url: '/apps/settings',
  },
]
